import React, { useState, useEffect } from 'react';

export const GlobalTimerContext = React.createContext<Date | null>(null);

export const GlobalTimerProvider: React.FC = ({ children }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const updateCurrentTime = () => {
      setCurrentTime(new Date());
    };

    const now = new Date();
    const millisecondsUntilNextMinute = 60000 - (now.getSeconds() * 1000 + now.getMilliseconds());

    // Set a timeout to synchronize with the next exact minute
    const timeout = setTimeout(() => {
      updateCurrentTime();
      // Start an interval to update the time every minute
      const interval = setInterval(updateCurrentTime, 60000);

      return () => clearInterval(interval);
    }, millisecondsUntilNextMinute);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <GlobalTimerContext.Provider value={currentTime}>
      {children}
    </GlobalTimerContext.Provider>
  );
};

export const useGlobalTimer = () => {
  const context = React.useContext(GlobalTimerContext);
  if (!context) {
    throw new Error(
      "useGlobalTimer must be used within a GlobalTimerProvider. Wrap a parent component in <GlobalTimerProvider> to fix this error."
    );
  }
  return context;
};
